import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLTable,
  InputGroup,
  Popover,
  TextArea,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import * as React from "react";
import { api_adm } from "../../api";
import { IEan, IItem, newIItem } from "../../model";
import { Pager } from "../utils/Pager";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { AppStore } from "../../stores/AppStore";
import { CfopStore } from "../../stores/legislacao/CfopStore";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { toast } from "react-toastify";
import LoadingModal from "../loading/LoadingModal";
var debounce = require('lodash.debounce');

@observer
export class CfopsPage extends React.Component<{}, {}> {

  obs = observable({
    cfop: newIItem() as IItem,
    open_create: false as boolean,
    open_edit: false as boolean,
    fetchOptions: {} as any
  })

  constructor(props: {}) {
    super(props);

    this.obs.fetchOptions = debounce(this.handldeSearch.bind(this), 800);

  }

  async componentDidMount() {
    AppStore.setTitle("CFOPs");

    await CfopStore.index_cfops(1, "");

  }

  handlePageChange = async (page: number) => {

    CfopStore.obs.current_page = page

    await CfopStore.index_cfops(page, CfopStore.obs.filter);

  };

  async handldeSearch() {

    await CfopStore.index_cfops(1, CfopStore.obs.filter);

  }

  async handldeFilter(filter: string) {

    CfopStore.obs.current_page = 1
    CfopStore.obs.filter = filter

    this.obs.fetchOptions()

  }

  async handleDeleteCfop(id) {

    let res = await CfopStore.handleDeleteCfop(id)

    if (res) {

      CfopStore.obs.current_page = 1
      CfopStore.obs.filter = ""

      await CfopStore.index_cfops(1, "");


    }

  }

  handleEditCfop = (row) => {

    this.obs.cfop = row;

    this.obs.open_edit = true

  };

  onClose() {

    this.obs.open_create = false
    this.obs.open_edit = false

    this.obs.cfop = newIItem();

  }

  async handleCreate() {

    if (this.obs.cfop.codigo == "") {
      toast.warning('Código obrgatório!', {});
      return
    }

    if (this.obs.cfop.descricao == "") {
      toast.warning('Descrição obrgatória!', {});
      return
    }

    this.obs.open_create = false
    CfopStore.obs.loading = true

    let resp = await CfopStore.handleCreateCfop(this.obs.cfop)

    if (resp) {

      CfopStore.obs.current_page = 1
      CfopStore.obs.filter = ""

      await CfopStore.index_cfops(1, "");

    }

    CfopStore.obs.loading = false
    this.obs.cfop = newIItem();

  }

  async handleSave() {

    if (this.obs.cfop.codigo == "") {
      toast.warning('Código obrgatório!', {});
      return
    }

    if (this.obs.cfop.descricao == "") {
      toast.warning('Descrição obrgatória!', {});
      return
    }

    this.obs.open_edit = false
    CfopStore.obs.loading = true

    let resp = await CfopStore.handleUpdateCfop(this.obs.cfop)

    if (resp) {

      CfopStore.obs.current_page = 1
      CfopStore.obs.filter = ""

      await CfopStore.index_cfops(1, "");

    }

    CfopStore.obs.loading = false
    this.obs.cfop = newIItem();

  }

  render() {

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    let rows = CfopStore.obs.cfops?.map((value) => {
      return ({
        id: (value._id || value.id),
        codigo: value.codigo,
        descricao: value.descricao,
      });
    });

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm">
            <img src="/images/edit.png" width={20} onClick={(e) => this.handleEditCfop(row)} />
          </MDBBtn>

          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>

            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={20} />
            </MDBBtn>

            <div>
              <H5>Confirmar exclusão?</H5>
              <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>
                <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleDeleteCfop(row.id)}>Excluir</Button>
              </div>

            </div>
          </Popover>
        </>
      );
    }

    return (
      <>

        {user_admin &&
          <>
            <MDBRow>
              <MDBCol md="12">
                <MDBBtn className="btnDefault noFloat" onClick={() => this.obs.open_create = true} style={{ marginRight: 10 }}>
                  Novo CFOP
                </MDBBtn>
              </MDBCol>
            </MDBRow>
            <br />
          </>
        }

        <MDBRow>
          <MDBCol md="6">
            <InputGroup
              round
              leftIcon="search"
              style={{ width: 600, borderRadius: 10 }}
              placeholder="Filtrar..."
              onChange={(e: any) => this.handldeFilter(e.target.value)} />
          </MDBCol>
        </MDBRow>

        <BootstrapTable className="TableDefault" data={rows} hover>
          <TableHeaderColumn dataField="codigo" isKey={true} width="10%">Código</TableHeaderColumn>
          <TableHeaderColumn dataField="descricao" width="90%">Descrição</TableHeaderColumn>
          {user_admin && <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Ações</TableHeaderColumn>}
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={CfopStore.obs.current_page}
            totalCount={CfopStore.obs.length_cfops}
            pageSize={50}
            onPageChange={this.handlePageChange} />
        </div>

        <Dialog
          isOpen={this.obs.open_create}
          title="Criando CFOP"
          onClose={() => this.onClose()}
          style={{ width: 800, height: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>

            <FormGroup
              label="Código"
              labelFor="codigo"
            >
              <InputGroup
                id="codigo"
                onChange={(e: any) => this.obs.cfop.codigo = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <TextArea
                id="descricao"
                style={{ width: "100%" }}
                onChange={(e: any) => this.obs.cfop.descricao = e.target.value}
              />
            </FormGroup>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.onClose()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleCreate()} />
            </div>
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_edit}
          title="Editando CFOP"
          onClose={() => this.onClose()}
          style={{ width: 800, height: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Código"
              labelFor="codigo"
            >
              <InputGroup
                id="codigo"
                onChange={(e: any) => this.obs.cfop.codigo = e.target.value}
                value={this.obs.cfop.codigo}
              />
            </FormGroup>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <TextArea
                id="descricao"
                style={{ width: "100%" }}
                onChange={(e: any) => this.obs.cfop.descricao = e.target.value}
                value={this.obs.cfop.descricao}

              />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.onClose()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleSave()} />
            </div>
          </div>

        </Dialog>

        <LoadingModal open={CfopStore.obs.loading} onClose={() => CfopStore.obs.loading = false} title={"Salvando"} />

      </>
    );
  }
}

export default CfopsPage;
